import AnimationAwaiter from './lib/AnimationAwaiter';

export default AnimationAwaiter;
